import { feedbackcard } from '@yes.technology/react-toolkit'
import { resolveQuery } from 'filteraction/FilteractionResolver'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useSiteState } from 'siteState/shared'
import { toYesFilter } from '../../../shared/toYesFilter/toYesFilter'
import { GroupedFieldValues } from '../../../types'
import { removeEmptyValuesGrouped } from '../utils/removeEmptyValues'

export type UseFilterFormSubmitParams = {
  onSubmit?: (query: ReturnType<typeof toYesFilter>) => void
}

const useFilterFormSubmit = ({ onSubmit }: UseFilterFormSubmitParams) => {
  const { t, language } = useTranslation()
  const [_, setSiteFieldValues] =
    useSiteState<GroupedFieldValues>('field-values')
  const [, setSiteFieldComposition] = useSiteState<string>('field-composition')

  const submitFieldValues = useCallback(
    async (fieldValues: GroupedFieldValues, compositionValue: string) => {
      const groupedValuesNoEmpty = removeEmptyValuesGrouped(fieldValues)

      const query = toYesFilter({
        groups: groupedValuesNoEmpty,
        composition: compositionValue,
        language
      })

      if (!Object.keys(query).length) {
        feedbackcard(t('generic-error'), {
          type: 'error',
          message: t('filter-fields.invalid-filter-action-format')
        })
        return
      }

      try {
        const resolvedQuery = await resolveQuery(
          query,
          console.log,
          [],
          true,
          true
        )

        resolvedQuery && onSubmit?.(resolvedQuery)
        resolvedQuery && setSiteFieldValues(groupedValuesNoEmpty)
        setSiteFieldComposition(compositionValue)
      } catch (error) {
        console.error('Error fetching filteraction', error)
        feedbackcard(t('generic-error'), {
          type: 'error',
          message: t('filter-fields.invalid-filter-action-format')
        })
      }
    },
    [language, onSubmit, setSiteFieldValues, setSiteFieldComposition, t]
  )

  return { submitFieldValues }
}

export default useFilterFormSubmit
